<template>
  <div id="app" class="app">
    <!-- Top navigation -->
    <nav
      class="navbar has-background-grey-dark is-transparent is-fixed-top"
      role="navigation"
      aria-label="main navigation"
    >
      <div class="navbar-brand">
        <div class="navbar-item">
          <img src="/img/logos/logo-text.png" width="140" height="35" />
          <span class="admin-subtitle has-text-light has-text-weight-bold">admin</span>
        </div>
      </div>

      <div class="navbar-menu">
        <div class="navbar-start" v-if="signedInUser">
          <router-link to="/search" class="navbar-item">
            <span class="link">
              <span class="icon">
                <i class="icon-search" aria-hidden="true"></i>
              </span>
              <span>Search</span>
            </span>
          </router-link>

          <router-link to="/animals" class="navbar-item">
            <span class="link">
              <span class="icon">
                <i class="icon-twitter" aria-hidden="true"></i>
              </span>
              <span>Animals</span>
            </span>
          </router-link>

          <router-link to="/ads" class="navbar-item">
            <span class="link">
              <span class="icon">
                <i class="icon-film" aria-hidden="true"></i>
              </span>
              <span>Ads</span>
            </span>
          </router-link>

          <router-link to="/resources" class="navbar-item">
            <span class="link">
              <span class="icon">
                <i class="icon-archive" aria-hidden="true"></i>
              </span>
              <span>Resources</span>
            </span>
          </router-link>

          <a href="https://adm.wehuntapp.com/gpsimport/" target="_blank" class="navbar-item">
            <span class="link">
              <span class="icon">
                <i class="icon-link" aria-hidden="true"></i>
              </span>
              <span>Minifinder GPS import</span>
            </span>
          </a>
        </div>
      </div>

      <div class="navbar-end">
        <div class="navbar-item has-dropdown is-hoverable" v-if="signedInUser">
          <a class="navbar-link has-text-light">
            <i class="icon-user has-text-light" aria-hidden="true"></i>
            <span>{{ signedInUser.name }}</span>
          </a>

          <div class="navbar-dropdown is-right">
            <a class="navbar-item" @click="signOut">
              <span class="icon">
                <i class="icon-power" aria-hidden="true"></i>
              </span>
              <span>Sign out</span>
            </a>
          </div>
        </div>
      </div>
    </nav>

    <!-- Content area -->
    <RouterView />
  </div>
</template>

<script>
import session from '@/api/session.js'
import { eventManager } from '@/eventManager.js'

export default {
  data() {
    return {
      signedInUser: false
    }
  },

  created() {
    this.signedInUser = session.getSignedInUser()

    eventManager.$on('session-state-changed', () => {
      if (session.isValid()) {
        this.signedInUser = session.getSignedInUser()
      } else {
        this.signedInUser = undefined
      }
    })
  },

  mounted() {
    if (!session.isValid()) {
      this.$router.push({ name: 'signin' })
    }
  },

  methods: {
    signOut() {
      session.clear()
      this.$router.push({ name: 'signin' })
    }
  }
}
</script>

<style lang="scss">
@import '@/assets/scss/style.scss';

html {
  height: 100%;
}

body {
  height: 100%;
}

.app {
  height: 100%;
}

.navbar-brand .navbar-item img {
  max-height: 2.25rem !important;
}

.navbar-brand .navbar-item .admin-subtitle {
  align-self: flex-end;
}

.navbar-link i {
  margin-right: 0.5em;
}

.navbar-start {
  margin: 0;
  flex-grow: 1;
  justify-content: center !important;

  a {
    padding: 0;
    margin-right: 1.5em;
  }

  a.navbar-item {
    color: $light;

    span.link {
      display: flex;
      padding-left: 4px;
      padding-right: 4px;
      padding-top: 5px;
      padding-bottom: 2px;

      .icon {
        margin-left: -0.5em;
      }
    }
  }

  a.navbar-item:hover {
    color: $grey-light;
  }

  a.navbar-item.router-link-active,
  a.navbar-item.router-link-active:focus,
  a.navbar-item.router-link-active:active {
    span.link {
      border-bottom: 2px solid $light;
      padding-bottom: 0;
    }
  }
}
</style>
